import { fetchPayoutsByCampaign } from 'modules/campaigns/reducers/payouts/campaign-payouts';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT, danger, success } from 'redux-store/reducers/common-reducer';

import { API, get, post, put } from 'utils/api';
import { createReducer } from 'utils/redux';
import { logError } from 'utils/log';
import { t } from 'utils/language';

const { PAYOUTS } = API.END_POINTS;

const PAYOUTS_LOADING = 'subcampaign/PAYOUTS_LOADING';
const PAYOUTS_LOADED = 'subcampaign/PAYOUTS_LOADED';
const PAYOUTS_ADDED = 'subcampaign/PAYOUTS_ADDED';
const PAYOUTS_UPDATED = 'subcampaign/PAYOUTS_UPDATED';
const PAYOUTS_RESET = 'subcampaign/PAYOUTS_RESET';

import type { Action, Dispatch, Payout, ThunkAction } from 'types';

const initialState = {
  payouts: [],
  isLoading: false
};

function payoutsLoaded(data: Array<Payout>): Action {
  return {
    type: PAYOUTS_LOADED,
    payload: {
      data
    }
  };
}

function payoutsAdded(): Action {
  return {
    type: PAYOUTS_ADDED
  };
}

function payoutsUpdated(): Action {
  return {
    type: PAYOUTS_UPDATED
  };
}

function setLoadingStatus(status: boolean): Action {
  return {
    type: PAYOUTS_LOADING,
    payload: {
      status
    }
  };
}

export function resetPayoutsBySubcampaign(): Action {
  return {
    type: PAYOUTS_RESET
  };
}

export function fetchPayoutsBySubcampaign(subcampaignId: number): ThunkAction {
  return async (dispatch: Dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      const url = PAYOUTS.handlePayoutsBySubcampaign(subcampaignId);
      const response = (await get(url)) as { data: Array<Payout> };

      dispatch(payoutsLoaded(response.data));
    } catch (e) {
      dispatch(setLoadingStatus(false));
      logError(e);
    }
  };
}

export function createPayoutsBySubcampaign(payouts: Array<Payout>, campaignId: number, subcampaignId: number): ThunkAction {
  const url = PAYOUTS.handlePayoutsBySubcampaign(subcampaignId);

  return async (dispatch: Dispatch) => {
    dispatch(showLoading(url));

    try {
      await post(url, { data: payouts });

      dispatch(payoutsAdded());
      dispatch(fetchPayoutsByCampaign(campaignId));
      dispatch(hideLoading(url));
      dispatch(success(t('campaign_payouts.installments_save_success')));
    } catch (e) {
      dispatch(hideLoading(url));
      dispatch(danger(t('campaign_payouts.installments_save_error')));
      logError(e);
    }
  };
}

export function updatePayoutsBySubcampaign(payouts: Array<Payout>, campaignId: number, subcampaignId: number): ThunkAction {
  const url = PAYOUTS.handlePayoutsBySubcampaign(subcampaignId);

  return async (dispatch: Dispatch) => {
    dispatch(showLoading(url));

    try {
      await put(url, { data: payouts });

      dispatch(payoutsUpdated());
      dispatch(fetchPayoutsByCampaign(campaignId));
      dispatch(hideLoading(url));
      dispatch(success(t('campaign_payouts.installments_save_success')));
    } catch (e) {
      dispatch(hideLoading(url));
      dispatch(danger(t('campaign_payouts.installments_save_error')));
      logError(e);
    }
  };
}

export default createReducer<any, any>('subcampaignPayouts', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [PAYOUTS_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [PAYOUTS_RESET]: (state) => ({
    ...state,
    payouts: []
  }),
  [PAYOUTS_LOADED]: (state, { data }) => ({
    ...state,
    payouts: data,
    isLoading: false
  }),
  [PAYOUTS_ADDED]: (state) => ({
    ...state,
    isLoading: false
  }),
  [PAYOUTS_UPDATED]: (state) => ({
    ...state,
    isLoading: false
  })
});
